import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { AuthContext } from '../../hooks/context/authContext';
import {handleFind, initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from '../../helper/utils';
import Wrapper from '../../components/atoms/DirectorioWrapper';
import PageHeader from '../../components/pageHeader/PageHeader';
import SearchBar from '../../components/pageComponents/SearchBar';
import FormSelect from '../../components/atoms/Select';
import PageButtons from '../../components/pageComponents/PageButtons';
import PaginatorV2 from '../../components/pageComponents/PaginatorV2';
import SpinnerLoading from '../../components/pageComponents/SpinnerLoading';
import TableWebBodyEvaluaciones from './TableWebBodyEvaluaciones';
import ModalMensaje from '../../components/modalMensaje/ModalMensaje';
import ModalVistaPrevia from './ModalVistaPrevia';
import { mostrarMensajeDeErrorConToast, responseCode200 } from '../../consumers/httpRequiestsUtils';
import { getAllEvaluacionesAPI } from '../../consumers/backendApisUrls';
import SidebarProcesosSeleccion from '../../components/pageComponents/SidebarProcesosSeleccion';

const EvaluacionesProcesos = () => {
  // Remover console.log en cada render para evitar spam
  
  const history = useHistory();
  const KEYS_FILTERS = { TiposCargo: "IdsTiposCargo", Niveles: "IdsNiveles", Especialidades: "IdsEspecialidades" };
  const { state } = useContext(AuthContext);

  const [formValues, setFormValues] = useState([]);
  const [extraData, setExtraData] = useState({});
  const [allFilters, setAllFilters] = useState([]);
  const [filters, setFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [tableRefreshLoading, setTableRefreshLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1, TotalPages: 1, TotalItems: 5 });
  const [showModalCrear, setShowModalCrear] = useState(false);
  const [evaluacionToEdit, setEvaluacionToEdit] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  
  // Estados para modal de confirmación de eliminar
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [evaluacionAEliminar, setEvaluacionAEliminar] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showModalVistaPrevia, setShowModalVistaPrevia] = useState(false);
  const [evaluacionPreviewId, setEvaluacionPreviewId] = useState(null);
  


  const [executePost] = useManagePostRequest();
  const [executeGet] = useGetRequest();



  const filtrosEstaticos = [
    {
      key: "TiposCargo",
      label: "Tipo de Cargo",
      options: [
        { value: "1", label: "Docente" },
        { value: "2", label: "Asistente" },
        { value: "3", label: "Administrativo" }
      ]
    },
    {
      key: "Niveles", 
      label: "Niveles",
      options: [
        { value: "1", label: "Inicial" },
        { value: "2", label: "Primaria" },
        { value: "3", label: "Secundaria" }
      ]
    },
    {
      key: "Especialidades",
      label: "Especialidades", 
      options: [
        { value: "1", label: "Matemática" },
        { value: "2", label: "Comunicación" },
        { value: "3", label: "Historia" },
        { value: "4", label: "Arte" },
        { value: "5", label: "Educación Inicial" }
      ]
    }
  ];

  const allFiltersPromises = () => {
    return [
      // Promesa simulada para filtros - retornar datos estáticos
      Promise.resolve({ data: [], success: true, responseMessage: "OK" })
    ];
  };

  useEffect(() => {
    console.log('🔥 useEffect init ejecutándose');
    init();
  }, []);

  // Búsqueda en tiempo real con debounce
  useEffect(() => {
    if (searchCriteria === '') {
      // Si el campo está vacío, cargar todas las evaluaciones inmediatamente
      manageSearch(1, false);
      return;
    }

    // Debounce de 500ms para evitar demasiadas llamadas al API
    const timeoutId = setTimeout(() => {
      console.log('🔍 Búsqueda automática ejecutándose con:', searchCriteria);
      manageSearch(1, true);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchCriteria]);

  const init = async () => {
    console.log('🚀 init función ejecutándose');
    setLoading(true);
    try {
      await initialAllOptionPromises(allFiltersPromises, Object.values(KEYS_FILTERS), setAllFilters);
      setExtraData({});
      await manageSearch(1, false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Función para generar evaluaciones de ejemplo en modo degradado
  // NOTA: Eliminada - ahora se llama al servicio real

  const manageSearch = async (pageNumber = 1, showLoading = true) => {
    // Asegurar que pageNumber es un número
    const pageNum = typeof pageNumber === 'number' ? pageNumber : 1;
    
    if (showLoading) setSearchLoading(true);
    
    try {
      console.log('🔍 Llamando al API de evaluaciones con parámetros:', {
        searchCriteria: searchCriteria.trim(),
        pageNumber: pageNum,
        pageSize: 20
      });
      
      console.log('🌐 URL del API generada:', getAllEvaluacionesAPI(searchCriteria.trim(), pageNum, 20));
      
      // Llamar al API real
      const api = getAllEvaluacionesAPI(searchCriteria.trim(), pageNum, 20);
      const response = await executeGet(api);
      
      console.log('📡 Respuesta del API recibida:', response);
      console.log('📡 Estructura completa response.data:', response?.data);
      
      if (response && responseCode200(response) && response.data && response.data.data) {
        // Acceder a los datos según la estructura real del API
        let evaluacionesData = [];
        
        // Estructura real del API: {data: {data: {Data: [...]}}}
        if (response.data.data.Data && Array.isArray(response.data.data.Data)) {
          evaluacionesData = response.data.data.Data;
        }
        
        console.log('📊 Evaluaciones encontradas:', evaluacionesData.length, evaluacionesData);
        
        // Mapear los datos según los campos reales del API
        const evaluaciones = evaluacionesData.map(evaluacion => ({
          IdEvaluacion: evaluacion.idEvaluacion,
          FechaCreacion: evaluacion.fechaCreacionTexto || 'N/A',
          NombreEvaluacion: evaluacion.nombreEvaluacion,
          TipoCargo: evaluacion.tipoCargo || 'Sin especificar',
          Cargo: evaluacion.cargo || 'Sin especificar',
          Nivel: 'Sin especificar', // No viene en el API
          Especialidad: 'Sin especificar', // No viene en el API
          Estado: evaluacion.estado ? 'Activo' : 'Inactivo',
          TipoEvaluacion: evaluacion.tipoEvaluacion || 'Sin especificar',
          // Datos adicionales para posible uso futuro
          _raw: evaluacion
        }));
        
        console.log('🎯 Evaluaciones mapeadas:', evaluaciones);
        
        // Crear respuesta con estructura de paginación esperada
        const apiResponse = {
          data: {
            data: {
              Data: {
                Items: evaluaciones,
                TotalItems: Number(response.data.data.totalItems || evaluaciones.length),
                FirsItemPage: Number(((pageNum - 1) * 20) + 1),
                LastItemPage: Number(Math.min(pageNum * 20, response.data.data.totalItems || evaluaciones.length)),
                TotalPages: Number(response.data.data.totalItems ? Math.ceil(response.data.data.totalItems / 20) : Math.ceil(evaluaciones.length / 20)),
                CurrentPage: Number(pageNum)
              }
            }
          }
        };
        
        sucessManageSearchCallback(apiResponse);
        console.log('✅ Evaluaciones cargadas exitosamente:', evaluaciones.length);
        
      } else {
        console.error('❌ Respuesta del API inválida:', response);
        console.error('❌ response.data:', response?.data);
        console.error('❌ responseCode200 result:', responseCode200(response));
        mostrarMensajeDeErrorConToast('Error al cargar las evaluaciones. Por favor, intente nuevamente.', 'error');
      }
      
    } catch (error) {
      console.error('❌ Error en manageSearch:', error);
      mostrarMensajeDeErrorConToast('Error al cargar las evaluaciones: ' + (error.message || 'Error desconocido'), 'error');
    } finally {
      if (showLoading) setSearchLoading(false);
    }
  };

  const manageSearchForPaginator = async () => {
    await manageSearch(Number(paginator.CurrentPage) || 1, false);
  };

  const sucessManageSearchCallback = async (response) => {
    const responseData = response?.data.data?.Data;
    
    if (responseData) {
      // Si viene con estructura de paginación (búsqueda paginada)
      if (responseData.Items) {
        setFormValues(Array.isArray(responseData.Items) ? responseData.Items : []);
        setPaginator({ 
          TotalItems: Number(responseData.TotalItems) || 0,
          FirsItemPage: Number(responseData.FirsItemPage) || 1,
          LastItemPage: Number(responseData.LastItemPage) || 0,
          TotalPages: Number(responseData.TotalPages) || 1,
          CurrentPage: Number(responseData.CurrentPage) || 1
        });
      } else {
        // Fallback para respuesta simple (sin búsqueda)
        const evaluacionesData = responseData || [];
        setFormValues(Array.isArray(evaluacionesData) ? evaluacionesData : []);
        setPaginator({ 
          TotalItems: Number(Array.isArray(evaluacionesData) ? evaluacionesData.length : 0), 
          FirsItemPage: 1, 
          LastItemPage: Number(Array.isArray(evaluacionesData) ? evaluacionesData.length : 0), 
          TotalPages: 1, 
          CurrentPage: 1 
        });
      }
    }
  };

  const limpiarBusqueda = async () => {
    setSearchCriteria("");
    setPaginator(lastData => ({ ...lastData, CurrentPage: 1 }));
    setSelectedFilters({});
    
    // Hacer búsqueda con searchText vacío para mostrar todos los resultados
    setSearchLoading(true);
    
    try {
      const api = getAllEvaluacionesAPI("", 1, 20); // searchText vacío
      const response = await executeGet(api);
      
      if (response && responseCode200(response) && response.data && response.data.data) {
        let evaluacionesData = [];
        
        if (response.data.data.Data && Array.isArray(response.data.data.Data)) {
          evaluacionesData = response.data.data.Data;
        }
        
        const evaluaciones = evaluacionesData.map(evaluacion => ({
          IdEvaluacion: evaluacion.idEvaluacion,
          FechaCreacion: evaluacion.fechaCreacionTexto || 'N/A',
          NombreEvaluacion: evaluacion.nombreEvaluacion,
          TipoCargo: evaluacion.tipoCargo || 'Sin especificar',
          Cargo: evaluacion.cargo || 'Sin especificar',
          Nivel: 'Sin especificar',
          Especialidad: 'Sin especificar',
          Estado: evaluacion.estado || 'Activo'
        }));
        
        setFormValues(evaluaciones);
        
        // Actualizar paginador si hay información de paginación
        if (response.data.data.Pagination) {
          setPaginator({
            CurrentPage: Number(response.data.data.Pagination.CurrentPage) || 1,
            TotalPages: Number(response.data.data.Pagination.TotalPages) || 1,
            TotalItems: Number(response.data.data.Pagination.TotalItems) || evaluaciones.length,
            FirsItemPage: 1,
            LastItemPage: Number(evaluaciones.length)
          });
        } else {
          setPaginator({
            CurrentPage: 1,
            TotalPages: 1,
            TotalItems: Number(evaluaciones.length),
            FirsItemPage: 1,
            LastItemPage: Number(evaluaciones.length)
          });
        }
      }
    } catch (error) {
      console.error('❌ Error al limpiar búsqueda:', error);
      mostrarMensajeDeErrorConToast("Error al cargar las evaluaciones");
    } finally {
      setSearchLoading(false);
    }
  };

  const addEvaluacionToList = (newEvaluacion) => {
    setFormValues(currentValues => [newEvaluacion, ...currentValues]);
    setPaginator(prev => ({
      ...prev,
      TotalItems: prev.TotalItems + 1,
      LastItemPage: Math.min(prev.LastItemPage + 1, prev.TotalItems + 1)
    }));
  };

  const removeEvaluacionFromList = (idEvaluacion) => {
    setFormValues(currentValues => 
      currentValues.filter(evaluacion => 
        evaluacion.IdEvaluacion !== idEvaluacion && 
        evaluacion.idEvaluacion !== idEvaluacion
      )
    );
    setPaginator(prev => ({
      ...prev,
      TotalItems: Math.max(prev.TotalItems - 1, 0),
      LastItemPage: Math.max(prev.LastItemPage - 1, 0)
    }));
  };

  const refreshData = async () => {
    await manageSearch(paginator.CurrentPage || 1, true);
  };

  const refreshTableAfterEdit = async () => {
    setTableRefreshLoading(true);
    try {
      await manageSearch(paginator.CurrentPage || 1, false);
    } catch (error) {
      console.error('Error en refreshTableAfterEdit:', error);
    } finally {
      setTableRefreshLoading(false);
    }
  };

  const handleFilterSelected = (res, filterKey) => {
    console.log('🔍 Filter selected:', res, 'for key:', filterKey);
    setSelectedFilters(prev => ({
      ...prev,
      [filterKey]: res
    }));
    // Aplicar filtros después de un delay para mejorar la experiencia
    setTimeout(() => {
      manageSearch(1, true);
    }, 300);
  };

  const updateEvaluacionInList = (updatedEvaluacion) => {
    console.log('🔄 updateEvaluacionInList iniciando con:', updatedEvaluacion);
    
    setFormValues(currentValues => {
      const newValues = currentValues.map(evaluacion => {
        if (evaluacion.IdEvaluacion === updatedEvaluacion.IdEvaluacion) {
          console.log('🎯 Evaluación encontrada para actualizar:', evaluacion.IdEvaluacion);
          console.log('📝 Datos anteriores:', evaluacion);
          console.log('📝 Datos nuevos:', updatedEvaluacion);
          return { ...evaluacion, ...updatedEvaluacion };
        }
        return evaluacion;
      });
      
      console.log('✅ Lista actualizada');
      return newValues;
    });
  };

  const handleCreateEvaluacion = () => {
    console.log('🔵 handleCreateEvaluacion ejecutado - redirigiendo a crear evaluación (usando EditarEvaluacion sin ID)');
    history.push('/editar-evaluacion');
  };

  const handleCloseModal = () => {
    setShowModalCrear(false);
    setEvaluacionToEdit(null);
    setIsEditMode(false);
  };

  const handleEvaluacionCreated = (evaluacion, isEdit = false) => {
    console.log('✅ Evaluación creada/editada:', { evaluacion, isEdit });
    if (isEdit) {
      updateEvaluacionInList(evaluacion);
    } else {
      addEvaluacionToList(evaluacion);
    }
  };

  const handleEditEvaluacion = (evaluacion) => {
    console.log('📝 Editando evaluación:', evaluacion);
    // Navegar a la pantalla de edición con el ID como query param
    const evaluacionId = evaluacion.IdEvaluacion || evaluacion.id;
    if (evaluacionId) {
      history.push(`/editar-evaluacion?id=${evaluacionId}`);
    } else {
      console.error('❌ Error: No se puede editar esta evaluación. Evaluación sin ID:', evaluacion);
    }
  };

  const handleDeleteEvaluacion = (evaluacion) => {
    console.log('🗑️ Solicitando eliminar evaluación:', evaluacion);
    setEvaluacionAEliminar(evaluacion);
    setShowConfirmModal(true);
  };

  const handlePreviewEvaluacion = (evaluacion) => {
    if (evaluacion && evaluacion.IdEvaluacion) {
      setEvaluacionPreviewId(evaluacion.IdEvaluacion);
      setShowModalVistaPrevia(true);
    }
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
    setEvaluacionAEliminar(null);
  };

  const handleConfirmEliminar = async () => {
    if (!evaluacionAEliminar) return;
    
    setIsProcessing(true);
    
    try {
      // Simular eliminación - aquí se haría la llamada al API
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      removeEvaluacionFromList(evaluacionAEliminar.IdEvaluacion);
      
      handleCloseConfirmModal();
      console.log('✅ Evaluación eliminada correctamente');
    } catch (error) {
      console.error('❌ Error al eliminar evaluación:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const filterOption = handleFind(allFilters, selectedFilters, KEYS_FILTERS, setFilters);

  if (loading) return <SpinnerLoading />;

  return (
    <div className="app-wrapper">
      <div className="no-disponible-en-mobile">
        <div style={{ display: 'flex', alignItems: 'stretch', position: 'relative' }}>
          <div style={{ position: 'fixed', left: 0, top: 0, bottom: 0, width: '130px', overflowY: 'auto', zIndex: 100 }}>
            <SidebarProcesosSeleccion />
          </div>
          <Wrapper className="App" style={{ flex: 1, minWidth: 0, marginLeft: '130px' }}>
          <PageHeader title="Gestión de Evaluaciones de Procesos" />

          <div className="generic-buscador-container">
            <SearchBar 
              value={searchCriteria} 
              onChange={setSearchCriteria} 
              cleanSearch={limpiarBusqueda} 
              manageSearch={manageSearch}
              placeholder="Buscar evaluación"
              loading={searchLoading}
            />
            
            <PageButtons>
              <button 
                onClick={handleCreateEvaluacion}
                className='btn generic-button-buscador'
                disabled={searchLoading}
              >
                Crear Evaluación
              </button>
            </PageButtons>
          </div>

          <div className="container-fluid body-content">
            <div className="table-scroll pt-3">
              <table className="table table-hover">
                <thead className="listar-thead">
                  <tr className="font-gothan-medium">
                    <th className="text-center text-wrap px-1">Fecha Creación</th>
                    <th className="col-4 text-center">
                      <div style={{ width: "300px" }}>Nombre de Evaluación</div>
                    </th>
                    <th className="text-center" style={{ minWidth: "140px" }}>Tipo de Cargo</th>
                    <th className="text-center" style={{ minWidth: "100px" }}>Estado</th>
                    <th className="col-1 text-center">Acciones</th>
                  </tr>
                </thead>
                <TableWebBodyEvaluaciones
                  filas={formValues}
                  manageSearch={manageSearch}
                  onEditEvaluacion={handleEditEvaluacion}
                  onPreviewEvaluacion={handlePreviewEvaluacion}
                  isLoading={tableRefreshLoading}
                />
              </table>
              <PaginatorV2 
                paginator={paginator} 
                setPaginator={setPaginator} 
                manageSearch={manageSearchForPaginator} 
              />
            </div>
          </div>
        </Wrapper>
        </div>

        {/* Modal de confirmación para eliminar */}
        {showConfirmModal && (
          <ModalMensaje
            showModal={showConfirmModal}
            setShowModal={handleCloseConfirmModal}
            titulo="Confirmar Eliminación"
            mensaje={`¿Está seguro que desea eliminar la evaluación "${evaluacionAEliminar?.NombreEvaluacion}"?`}
            mostrarBotonConfirmar={true}
            mostrarBotonRechazar={true}
            onConfirm={handleConfirmEliminar}
            onReject={handleCloseConfirmModal}
            textoConfirmar={isProcessing ? "Eliminando..." : "Eliminar"}
            textoRechazar="Cancelar"
            isLoading={isProcessing}
          />
        )}
        
        {/* Modal de Vista Previa */}
        {showModalVistaPrevia && (
          <ModalVistaPrevia
            showModal={showModalVistaPrevia}
            onClose={() => {
              setShowModalVistaPrevia(false);
              setEvaluacionPreviewId(null);
            }}
            evaluacionId={evaluacionPreviewId}
          />
        )}
      </div>
    </div>
  );
};

export default EvaluacionesProcesos;